<div class="grid">
  <mat-progress-spinner class="spinner" color="accent" diameter="48" mode="indeterminate"></mat-progress-spinner>
</div>
